function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useContext, useState, useMemo, useRef } from 'react';
import { Input, Button, Popover } from 'antd';
import styles from './style/index.module.scss';
import { QuestionCircleOutlined, GithubOutlined } from '@ant-design/icons';
import ResponsiveContainer from './components/ResponsiveContainer';
import ResponsiveContextProvider, { ResponsiveContext } from './context';
var WorkspaceAttribute = function WorkspaceAttribute() {
  var _useContext = useContext(ResponsiveContext),
    select = _useContext.state.select,
    selectComSize = _useContext.selectComSize;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['workspace-attribute']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['workspace-attribute-title']
  }, "\u6240\u9009\u7EC4\u4EF6\u5C5E\u6027"), select && select != 'container' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles['workspace-attribute-line']
  }, "\u7EC4\u4EF6\u5BBD", /*#__PURE__*/React.createElement(Input, {
    disabled: true,
    value: selectComSize[0] + 'px',
    style: {
      width: '100px',
      marginLeft: '10px'
    },
    size: 'small'
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['workspace-attribute-line']
  }, "\u7EC4\u4EF6\u9AD8", /*#__PURE__*/React.createElement(Input, {
    disabled: true,
    value: selectComSize[1] + 'px',
    style: {
      width: '100px',
      marginLeft: '10px'
    },
    size: 'small'
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null));
};
var ResponsiveLayout = function ResponsiveLayout() {
  var _useContext2 = useContext(ResponsiveContext),
    onSelect = _useContext2.onSelect,
    select = _useContext2.state.select,
    comDragingRef = _useContext2.comDragingRef;
  var selectContentRef = useRef(null);
  useEffect(function () {
    document.body.style.margin = '0';
    return function () {
      document.body.style.margin = '';
    };
  }, []);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    hoverItemId = _useState2[0],
    setHoverItemId = _useState2[1];
  var HoverItemLineContent = useMemo(function () {
    if (!hoverItemId || select == hoverItemId) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    var hoverItem = document.querySelector("[data-com_id='".concat(hoverItemId, "']"));
    var selectRect = hoverItem === null || hoverItem === void 0 ? void 0 : hoverItem.getBoundingClientRect();
    if (!selectRect) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    } else {
      var parentDom = selectContentRef.current;
      var parentRect = parentDom === null || parentDom === void 0 ? void 0 : parentDom.getBoundingClientRect();
      var buttonTop = selectRect.top - parentRect.top;
      var buttonLeft = selectRect.left - parentRect.left;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: selectRect.width,
          height: selectRect.height,
          left: buttonLeft - 1,
          top: buttonTop - 1,
          border: '1px solid #2149a4',
          pointerEvents: 'none',
          position: 'absolute',
          zIndex: 8
        }
      });
    }
  }, [hoverItemId, select]);
  var SelectItemLineContent = useMemo(function () {
    if (!select) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    var selectItem = document.querySelector("[data-com_id='".concat(select, "']"));
    var selectRect = selectItem === null || selectItem === void 0 ? void 0 : selectItem.getBoundingClientRect();
    if (!selectRect) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    } else {
      var parentDom = selectContentRef.current;
      var parentRect = parentDom === null || parentDom === void 0 ? void 0 : parentDom.getBoundingClientRect();
      var buttonTop = selectRect.top - parentRect.top;
      var buttonLeft = selectRect.left - parentRect.left;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: selectRect.width,
          height: selectRect.height,
          left: buttonLeft - 1,
          top: buttonTop - 1,
          border: '1px solid #2149a4',
          boxShadow: '0 0 1px 1px #2149a4',
          pointerEvents: 'none',
          position: 'absolute',
          zIndex: 8
        }
      });
    }
  }, [select]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles['wrap'],
    onClick: function onClick(e) {
      var _target, _target2;
      e.stopPropagation();
      var target = e.target;
      while (!((_target$dataset = target.dataset) !== null && _target$dataset !== void 0 && _target$dataset['com_type']) && target.parentNode) {
        var _target$dataset;
        target = target.parentNode;
      }
      if (((_target = target) === null || _target === void 0 || (_target = _target.dataset) === null || _target === void 0 ? void 0 : _target['com_type']) == 'container') {
        onSelect('container');
      } else if (((_target2 = target) === null || _target2 === void 0 || (_target2 = _target2.dataset) === null || _target2 === void 0 ? void 0 : _target2['com_type']) == 'item') {
        var _target$dataset2;
        onSelect((_target$dataset2 = target.dataset) === null || _target$dataset2 === void 0 ? void 0 : _target$dataset2['com_id']);
      } else {
        onSelect('');
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['workspace-main']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['workspace-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['responsive-layout-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['responsive-layout-main-title']
  }, "wix\u5E03\u5C40", /*#__PURE__*/React.createElement(Popover, {
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, "1.\u53F3\u952E\u5355\u5143\u683C\u53EF\u4EE5\u62C6\u5206\u4E0E\u5220\u9664"), /*#__PURE__*/React.createElement("div", null, "2.\u9009\u4E2D\u5355\u5143\u683C\u53F3\u4FA7\u663E\u793A\u5355\u5143\u683C\u5BBD\u9AD8"), /*#__PURE__*/React.createElement("div", null, "3.\u62D6\u52A8\u5355\u5143\u683C\u4E4B\u95F4\u7684\u5206\u5272\u7EBF\u53EF\u4EE5\u6539\u53D8\u5355\u5143\u683C\u7684\u5BBD\u9AD8"), /*#__PURE__*/React.createElement("div", null, "4.\u5BB9\u5668\u5185\u6CA1\u6709\u5355\u5143\u683C\u65F6\u53EF\u4EE5\u9009\u62E9\u9884\u8BBE\u7684\u51E0\u79CD\u5E03\u5C40"), /*#__PURE__*/React.createElement("div", null, "5.\u5355\u5143\u683C\u6709\u5927\u5C0F\u9650\u5236\uFF0C\u592A\u5C0F\u5C06\u4E0D\u53EF\u5206\u5272\u4E0E\u62D6\u52A8")),
    title: '使用方法&包含功能'
  }, /*#__PURE__*/React.createElement(Button, {
    shape: "circle",
    style: {
      marginLeft: '10px'
    },
    type: "text",
    icon: /*#__PURE__*/React.createElement(QuestionCircleOutlined, null)
  })), /*#__PURE__*/React.createElement(Button, {
    shape: "circle",
    style: {
      marginLeft: '10px'
    },
    icon: /*#__PURE__*/React.createElement(GithubOutlined, null),
    target: '_blank',
    title: 'demo源码地址',
    href: 'https://github.com/Sorabb/sora-pages/tree/master/src/demo/responsive-layout'
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['responsive-layout-main-content'],
    onMouseOver: function onMouseOver(e) {
      var _target3;
      if (comDragingRef.current) {
        return;
      }
      e.stopPropagation();
      var target = e.target;
      while (!((_target$dataset3 = target.dataset) !== null && _target$dataset3 !== void 0 && _target$dataset3['com_type']) && target.parentNode) {
        var _target$dataset3;
        target = target.parentNode;
      }
      if (((_target3 = target) === null || _target3 === void 0 || (_target3 = _target3.dataset) === null || _target3 === void 0 ? void 0 : _target3['com_type']) == 'item') {
        var _target$dataset4;
        setHoverItemId((_target$dataset4 = target.dataset) === null || _target$dataset4 === void 0 ? void 0 : _target$dataset4['com_id']);
      } else {
        setHoverItemId('');
      }
    },
    onMouseOut: function onMouseOut() {
      setHoverItemId('');
    }
  }, /*#__PURE__*/React.createElement(ResponsiveContainer, null), /*#__PURE__*/React.createElement("div", {
    className: styles['responsive-layout-select-content'],
    ref: selectContentRef
  }, HoverItemLineContent, SelectItemLineContent)))), /*#__PURE__*/React.createElement(WorkspaceAttribute, null))));
};
export default (function () {
  return /*#__PURE__*/React.createElement(ResponsiveContextProvider, null, /*#__PURE__*/React.createElement(ResponsiveLayout, null));
});